import { useEffect, useState, ChangeEvent, useRef } from "react";
import { csColumns, metaData } from "../static-models/MemberReceiptTab_CS";
import { useAppSelector } from "../redux/hooks";
import formatDate from "../util/dateFormat";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  SelectChangeEvent,
  TextField,
  Typography,
  Drawer,
  CircularProgress,
} from "@mui/material";
import useButtonStyles from "../styles/useButtonStyles";
import RedeemCheckBox from "../CustomerPortal/RedeemCheckBox";
import axios from "axios";
import { APIConstants } from "../constants/ApiConstants";
import BasicModal from "../components/ui/BasicModal";
import theme from "../theme";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { getFeaturePermissions } from "../util/permissions";
import { operatorConstants } from "../util/SearchandFIlters/Constants";
import { getHashURL } from "../util/SearchandFIlters/searchAndFilter";
import InfiniteTable from "../components/Table/InfiniteScroll/InfiniteTable";
import AddReceipt from "../pages/AddReceipt";
import UpdateMemberReceipts from "../components/member/UpdateMemberReceipts";
import { useNavigate, useParams } from "react-router";
import {
  SearchToolTip,
  filterConstants,
  DateConstants,
  permissionsConstants,
} from "../constants/AppConstants";
import SearchInput from "../Shared/Components/SearchInput/SearchInput";
import useDebounce from "../Hooks/CustomHooks/debouncng";
import { getReceipts } from "../services/ApiServices/Receipts";
import {
  getEncodedLastkey,
  getEncodedValue,
} from "../components/forms/utility";
import { usePermissionGetter } from "../Hooks/Permissions/userPermissionGetter";
import { CommonButton } from "../Shared/Components/Buttons/CommonButton";

export interface MemberReceiptTabTableData {
  image: string;
  amount: number;
  calculated_receipt_amount: number;
  merchant: string;
  merchant_type: string;
  receipt_number: string;
  submission_date: string;
  status: string;
  review_date: string;
  points_awarded: number;
  birthday_points: number;
  payment_type: string;
  redeemed: boolean;
  id: string;
  receipt_status: string;
}
const listOfStatus = [
  filterConstants.Processing.toLowerCase(),
  filterConstants.Accept.toLowerCase(),
  filterConstants.Reject.toLowerCase(),
  filterConstants.Pending.toLowerCase(),
  filterConstants.Appeal.toLowerCase(),
];

const MemberReceiptTab = () => {
  const { getUserPermission: getReceiptsPermissions } = usePermissionGetter(
    permissionsConstants.member_redemption,
    permissionsConstants.receipts
  );
  const params = useParams();
  const navigate = useNavigate();
  const buttonStyles = useButtonStyles();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [filterActive, setFilterActive] = useState(false);
  const [eVoucher, setEVoucher] = useState([]);
  const [openAddReceipt, setOpenAddReceipt] = useState(false);
  const [memberReceiptData, setMemberReceiptData] = useState<
    MemberReceiptTabTableData[] | []
  >([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const permissions = useAppSelector(
    (state: any) => state.persistReducers.login.permissions
  );
  const [apiFromKey, setApiFromKey] = useState<Number>(0);
  const [nextPageKey, setNextPageKey] = useState<any>(null);
  const [isApiCall, setIsApiCall] = useState<boolean>(true);
  const [rewardLoading, setRewardLoading] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);
  const memberDetails = useAppSelector(
    (state: any) => state.persistReducers.getMemberList?.membersList
  );
  const [currentRoute, setCurrentRoute] = useState<string>(
    window.location.pathname
  );
  const [selectedItems, setSelectedItems] = useState<
    MemberReceiptTabTableData[]
  >([]);
  const [couponsFound, setCouponsFound] = useState<boolean>(false);
  const [receiptId, setReceiptId] = useState<string[]>([]);
  const [filterStates, setFilterStates] = useState<any>([]);
  const [maxReceipts, setMaxReceipts] = useState<number | null>(null);
  const [isSelectButtonDisabled, setIsSelectButtonDisabled] = useState(true);
  const [maxReceiptModal, setMaxReceiptModal] = useState<boolean>(false);
  const searchInputRef = useRef<HTMLInputElement>();
  const onDebounce = useDebounce();

  useEffect(() => {
    if (isApiCall) bindFilter();
  }, [isApiCall]);

  useEffect(() => {
    if (maxReceipts !== null) {
      const booleanVal = selectedItems.length > maxReceipts;
      setMaxReceiptModal(booleanVal);
    }
  }, [selectedItems]);

  const handleCloseModal = () => {
    setShowModal(false);
    setMaxReceiptModal(false);
  };

  const handleCheckboxChange = (
    item: MemberReceiptTabTableData,
    checked: boolean
  ) => {
    const updatedItems = checked
      ? [...selectedItems, item]
      : selectedItems.filter((selectedItem) => selectedItem !== item);
    setSelectedItems(updatedItems);
    maxReceipts &&
      setIsSelectButtonDisabled(
        updatedItems.length === 0 || updatedItems.length > maxReceipts
      );
  };

  const handleAllCheckboxChange = (
    item: MemberReceiptTabTableData[],
    checked: boolean
  ) => {
    setSelectedItems(checked ? item : []);
  };

  const fetchMemberReceipts = async (url: string, canMergerData?: boolean) => {
    try {
      let baseQuery = `fromKey=${apiFromKey}`;
      baseQuery += `&${url}`;
      baseQuery += "&module=member_redemption&feature=receipts";
      if (nextPageKey) baseQuery += `&${getEncodedLastkey(nextPageKey)}`;

      const responseData = await getReceipts(baseQuery);
      const { totalCount, result, fromKey, lastKey } = responseData;
      setApiFromKey(fromKey ? fromKey : 0);
      setNextPageKey(lastKey ? lastKey : null);
      const receiptData: any = result?.map((data: any) => {
        const receipt = data?._source;
        return {
          image: receipt.upload_log[0].receipt_image,
          id: receipt.id,
          amount: receipt.amount_bpo
            ? receipt.amount_bpo
            : receipt.amount_member,
          calculated_receipt_amount: receipt.amount_bpo,
          merchant: receipt.merchant_name !== "" ? receipt.merchant_name : "-",
          merchant_type:
            receipt.merchant_type !== "" ? receipt.merchant_type : "-",
          receipt_number: receipt.receipt_number,
          status: receipt.receipt_status ? receipt.receipt_status : "-",
          submission_date: formatDate(receipt.submission_date),
          review_date:
            receipt.reviewed_date !== "1970-01-01T00:00:00.000Z"
              ? formatDate(receipt.reviewed_date)
              : "-",
          points_awarded: receipt.points,
          birthday_points: 0,
          payment_type: receipt.payment_type,
          partner: receipt.partner ? receipt.partner : "-",
          redeemed: receipt.redeemed,
          receiptAmount: receipt.amount_bpo ? receipt.amount_bpo : "-",
          receiptDateTime: receipt.submission_date
            ? formatDate(receipt.submission_date)
            : "-",
          navigateTo: receipt.id ? `/memberRedemption/${receipt.id}` : "-",
        };
      });
      const filteredReceipts = receiptData.filter(
        (receipt: MemberReceiptTabTableData) =>
          receipt?.status !== filterConstants.Reject.toLowerCase() &&
          receipt?.redeemed === false
      );
      const dataToset = canMergerData
        ? [...memberReceiptData, ...filteredReceipts]
        : filteredReceipts;
      setMemberReceiptData(dataToset);
      setError(false);
    } catch (error) {
      setError(true);
    } finally {
      setIsApiCall(false);
    }
  };

  const uploadData = async (selectedReceipts: MemberReceiptTabTableData[]) => {
    setRewardLoading(true);
    try {
      const receiptIds = selectedReceipts?.map((receipt) => receipt.id);
      const payload = receiptIds;
      const axiosResponse = await axios.get(
        process.env.REACT_APP_API_URL + APIConstants.memberRedemption + payload
      );
      const eligibleOffers = axiosResponse?.data?.data?.eligible_offers;
      const offersData = eligibleOffers?.map(
        (offer: {
          id: any;
          name: any;
          availableQtyForPurchase: number;
          availableQuantity: number;
        }) => ({
          id: offer.id,
          name: offer.name,
          // quantity: offer.availableQtyForPurchase,
          availableQuantities: offer.availableQtyForPurchase,
          totalQuantities: offer.availableQuantity,
        })
      );

      const orderIds = eligibleOffers?.map((offer: { id: any }) => offer.id);
      const offerNames = eligibleOffers?.map(
        (offer: { name: any }) => offer.name
      );
      const availableQuantities = eligibleOffers?.map(
        (offer: { availableQtyForPurchase: number }) =>
          offer.availableQtyForPurchase
      );
      const totalQuantities = eligibleOffers?.map(
        (offer: { availableQuantity: number }) => offer.availableQuantity
      );

      setCouponsFound(eligibleOffers.length ? eligibleOffers : false);
      setEVoucher(offersData);
      setReceiptId(receiptIds);
      setShowModal(true);
    } catch (error) {
      setErrorMessage("Redemption failed, Please try again");
      setShowModal(true);
      console.error(error);
    } finally {
      setRewardLoading(false);
    }
  };

  const [filterState, setFilterState] = useState({
    merchant: "",
    receiptDate: "",
    submittedDate: "",
    reviewedDate: "",
    amountFrom: "",
    amountTo: "",
    adjAmountFrom: "",
    adjAmountTo: "",
    status: "",
  });

  const resetFilterState = () => {
    setFilterState({
      merchant: "",
      receiptDate: "",
      submittedDate: "",
      reviewedDate: "",
      amountFrom: "",
      amountTo: "",
      adjAmountFrom: "",
      adjAmountTo: "",
      status: "",
    });
    setFilterStates([]);
    resetData();
    setFilterActive(false);
  };

  const getAllFields = (fieldValue: any, value: any, operator?: any) => {
    const existingObject = filterStates.find(
      (obj: any) => obj.fieldValue === fieldValue
    );

    if (!existingObject) {
      setFilterStates((prev: any) => [
        ...prev,
        { fieldValue: fieldValue, value: value, operator: operator },
      ]);
    } else {
      setFilterStates((prev: any) =>
        prev?.map((obj: any) =>
          obj.fieldValue === fieldValue
            ? { ...obj, value: value, operator: operator }
            : obj
        )
      );
    }
  };

  const AdjustedAmount = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    getAllFields(
      "amount_bpo",
      `${filterState.adjAmountFrom},${
        (event.target as HTMLInputElement).value
      }`,
      operatorConstants.between
    );

    setFilterState((prev) => ({
      ...prev,
      adjAmountTo: (event.target as HTMLInputElement).value,
    }));
  };

  const applyReceiptsFilter = () => {
    resetData();
    setOpenFilter(false);
    setIsApiCall(true);
    filterStates.length && setFilterActive(true);
  };
  const handleSearch = () => {
    resetData();
    setIsApiCall(true);
  };

  const bindFilter = (canMergeData?: boolean) => {
    const hashValue = {
      field: "memberId",
      value: memberDetails.email,
    };
    // let queryParams= `filters=member:eq:${email}`
    const searchValue = searchInputRef.current
      ? getEncodedValue(searchInputRef.current.value)
      : "";
    const params = {
      hashData: hashValue,
      searchData: searchValue ? [searchValue] : [],
      filterData: filterStates,
    };
    const url = getHashURL(params);
    fetchMemberReceipts(url, canMergeData);
  };

  const resetData = () => {
    setApiFromKey(0);
    setNextPageKey(null);
    setMemberReceiptData([]);
  };
  const HandleStatusChange = (event: SelectChangeEvent) => {
    getAllFields(
      "receipt_status",
      (event.target as HTMLSelectElement).value,
      operatorConstants.equal
    );
    setFilterState((prev) => ({
      ...prev,
      status: event.target.value,
    }));
  };

  const amount = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    getAllFields(
      "amount_member",
      `${filterState.amountFrom},${(event.target as HTMLInputElement).value}`,
      operatorConstants.between
    );

    setFilterState((prev) => ({
      ...prev,
      amountTo: (event.target as HTMLInputElement).value,
    }));
  };

  const [openFilter, setOpenFilter] = useState(false);

  const handleClose = () => {
    setOpenFilter(false);
  };
  const [errorMessage, setErrorMessage] = useState<string>(
    "Something went wrong!"
  );
  useEffect(() => {
    if (params?.receiptsId) setOpenDrawer(true);
    else setOpenDrawer(false);
  }, [params]);

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
    navigate(`/memberRedemption`); // /${params?.memberId}`);
  };

  useEffect(() => {
    const fetchMaxReceipts = async () => {
      try {
        const response = await axios.get(
          process.env.REACT_APP_API_URL + APIConstants.getRedemptionOffers
        );
        const maxReceiptsValue = response?.data?.data?.max_receipts;
        setMaxReceipts(maxReceiptsValue ? maxReceiptsValue : null);
      } catch (error) {
        console.error("Error fetching maximum receipts:", error);
      }
    };

    fetchMaxReceipts();
  }, []);
  return (
    <>
      <Grid
        display={"flex"}
        justifyContent={"space-between"}
        direction={"row"}
        alignItems={"left"}
        py={3}
        gap={2}
      >
        <Dialog onClose={handleClose} open={openFilter} sx={{ ml: "60vw" }}>
          <Grid sx={{ width: "484px", py: 4, px: 2 }}>
            <DialogTitle
              display={"flex"}
              justifyContent={"space-between"}
              borderBottom={theme.border?.smallGrey}
            >
              <Typography
                sx={{
                  fontFamily: theme.font?.fontFamily.primary,
                  color: theme.color?.primary,
                  fontSize: theme.font?.fontSize.large,
                  fontWeight: theme.font?.fontWeight.thicker,
                }}
              >
                Filter
              </Typography>
              <IconButton
                onClick={() => {
                  setOpenFilter(false);
                }}
              >
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ borderBottom: theme.border?.smallGrey }}>
              <Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Receipt Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "80%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={filterState.receiptDate}
                      onChange={(e) => {
                        getAllFields(
                          "date_of_purchase",
                          new Date(e.target.value).getTime(),
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          receiptDate: e.target.value,
                        }));
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Submitted Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "80%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={filterState.submittedDate}
                      onChange={(e) => {
                        getAllFields(
                          "submission_date",
                          new Date(e.target.value).getTime(),
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          submittedDate: e.target.value,
                        }));
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Reviewed Date
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "80%",
                      }}
                      type="date"
                      size="small"
                      placeholder="Transaction Date"
                      value={filterState.reviewedDate}
                      onChange={(e) => {
                        getAllFields(
                          "reviewed_date",
                          new Date(e.target.value).getTime(),
                          operatorConstants.equal
                        );
                        setFilterState((prev) => ({
                          ...prev,
                          reviewedDate: e.target.value,
                        }));
                      }}
                      InputProps={{
                        inputProps: {
                          max: DateConstants.maxDate,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Amount ($)
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "38%",
                      }}
                      type="text"
                      size="small"
                      label="From"
                      value={filterState.amountFrom}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          amountFrom: e.target.value,
                        }))
                      }
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                    <TextField
                      sx={{
                        display: "flex",
                        width: "38%",
                      }}
                      type="text"
                      size="small"
                      label="To"
                      value={filterState.amountTo}
                      onChange={(e) => amount(e)}
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={3}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Adjusted Amount ($)
                  </Typography>
                  <Grid display={"flex"} gap={2} mt={2} direction={"row"}>
                    <TextField
                      sx={{
                        display: "flex",
                        width: "38%",
                      }}
                      type="text"
                      size="small"
                      label="From"
                      value={filterState.adjAmountFrom}
                      onChange={(e) =>
                        setFilterState((prev) => ({
                          ...prev,
                          adjAmountFrom: e.target.value,
                        }))
                      }
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />

                    <TextField
                      sx={{
                        display: "flex",
                        width: "38%",
                      }}
                      type="text"
                      size="small"
                      label="To"
                      value={filterState.adjAmountTo}
                      onChange={(e) => AdjustedAmount(e)}
                      InputLabelProps={{
                        shrink: true,
                        focused: true,
                        style: {
                          color: "black",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
                <Grid borderBottom={theme.border?.smallGrey} mt={5}>
                  <Typography
                    sx={{
                      fontFamily: theme.font?.fontFamily.primary,
                      fontSize: theme.font?.fontSize.medium,
                      fontWeight: theme.font?.fontWeight.thick,
                    }}
                  >
                    Status
                  </Typography>
                  <Grid
                    gap={2}
                    mt={2}
                    display={"flex"}
                    sx={{
                      width: "80%",
                    }}
                  >
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                        with: "100%",
                      }}
                    >
                      <Select
                        id=""
                        value={filterState.status}
                        onChange={HandleStatusChange}
                      >
                        {listOfStatus?.map((name: any) => (
                          <MenuItem value={name}>{name}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ pr: 4, gap: 1, pt: 2 }}>
              <Button
                sx={{ ...buttonStyles.outlinedSecondary }}
                onClick={() => {
                  resetFilterState();
                  setIsApiCall(true);
                }}
              >
                Reset
              </Button>
              <Button
                sx={{ ...buttonStyles.containedSecondary }}
                onClick={applyReceiptsFilter}
              >
                Apply
              </Button>
            </DialogActions>
          </Grid>
        </Dialog>
        <Grid display={"flex"} gap={3}>
          {getReceiptsPermissions("create") && (
            <CommonButton
              variant="contained"
              buttonTitle="Add Receipt"
              color="secondary"
              onClick={() => setOpenAddReceipt(true)}
            />
          )}
          {rewardLoading ? (
            <Button sx={{ ...buttonStyles.containedSecondary }}>
              <CircularProgress size={20} />
            </Button>
          ) : (
            <>
              {getReceiptsPermissions("update") && (
                <CommonButton
                  variant="contained"
                  color="secondary"
                  buttonTitle="Select Rewards"
                  onClick={() => {
                    if (selectedItems.length > 0) {
                      uploadData(selectedItems);
                    }
                  }}
                  disabled={isSelectButtonDisabled || maxReceipts === null}
                />
              )}
            </>
          )}
        </Grid>
        <Grid display={"flex"} gap={1} flex={1} justifyContent={"end"}>
          <SearchInput
            HelpTip={SearchToolTip.MemberReceipts}
            onCallBack={handleSearch}
            ref={searchInputRef}
          />
          {getReceiptsPermissions("read") && (
            <Button
              variant="text"
              startIcon={
                filterActive ? (
                  <FilterAltIcon sx={{ color: theme.color?.secondary }} />
                ) : (
                  <FilterAltOutlinedIcon />
                )
              }
              sx={{ color: theme.color?.newFilterGrey }}
              onClick={() => {
                setOpenFilter(true);
              }}
            >
              Filter
            </Button>
          )}
        </Grid>
      </Grid>
      <Drawer
        anchor={"right"}
        open={openAddReceipt}
        onClose={() => {
          setOpenAddReceipt(false);
        }}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"642px"} height={"100%"}>
          <AddReceipt
            closeDrawer={setOpenAddReceipt}
            refreshApi={() => {
              resetData();
              setIsApiCall(true);
            }}
            memberEmailDefault={true}
          />
        </Grid>
      </Drawer>
      <Drawer
        anchor={"right"}
        open={Boolean(openDrawer)}
        onClose={handleCloseDrawer}
        sx={{
          "& .MuiPaper-root": {
            borderRadius: "16px 0 0 16px",
          },
        }}
      >
        <Grid width={"920px"} height={"100%"}>
          <UpdateMemberReceipts
            onRefresh={() => {
              resetData();
              setIsApiCall(true);
            }}
            closeDrawer={handleCloseDrawer}
            module="member_redemption"
          />
        </Grid>
      </Drawer>

      {getReceiptsPermissions("read") && (
        <InfiniteTable
          header={csColumns}
          contentItems={memberReceiptData}
          metaData={metaData}
          fetchMoreData={() => bindFilter(true)}
          onInputChange={handleCheckboxChange}
          onHeaderAllCheckBoxChange={handleAllCheckboxChange}
          hasMoreRecords={nextPageKey !== null}
          isInitialLoading={isApiCall}
          totalRecords={memberReceiptData?.length}
          filterCondition={() => {
            return maxReceipts !== null;
          }}
        />
      )}
      {currentRoute === "/cs-admin/memberRedemption" && couponsFound && (
        <Grid style={{ width: "100%", marginTop: "2rem" }}>
          <RedeemCheckBox EVoucher={eVoucher} id={receiptId} />
        </Grid>
      )}
      {showModal && (
        <BasicModal
          title={
            couponsFound
              ? "E-voucher found !"
              : "No E-vouchers found for the selected receipts"
          }
          success={couponsFound}
          setState={handleCloseModal}
        />
      )}

      {maxReceiptModal && (
        <BasicModal
          title={`Please select only ${maxReceipts} receipts`}
          setState={handleCloseModal}
        />
      )}
    </>
  );
};

export default MemberReceiptTab;
